'use client'
import React from 'react'

const ApiContext = React.createContext<{
	apiUrl: string
}>({
	apiUrl: '',
})

export default ApiContext
